
import React from 'react';
import {Header, Breadcrumb, Container,Loader, Rating, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Checkbox, Popup, Icon, Segment, Image} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Tabla from "../common/ManageTabla";
import CurrencyInput from 'react-currency-input-field';
import { DatePicker, Space } from 'antd';
//import "antd/dist/antd.css";
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
const dateFormat = 'DD/MM/YYYY';

const CursoFormImagenes=({ id, color, form, usuarioCombo, tagCombo, cursoCombo, onSave,
                  headersTablaModulos, camposTablaModulos, moduloCombo, 
                  validacionesTablaModulos, onChange, archivos, onChangeCurrency, verModulo, 
                  tipoTablaModulos, ajaxCallInProgress, datos, errors, strings, permisos, fechas, onBuscar, onHandleFileImagen, imgBanner, imgThumb, imgPresentacion})=>{
    
  
    
	return (
        <Container>
          <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big' inline content={strings?strings["Procesando"]:""}/>
          </Dimmer>

			
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
       

        
                            <Form.Field  >
                                <label>{strings?strings["imagenBanner"]:""} </label>
                                <Input placeholder='imagenBanner'
                                onChange={(a, b)=>onHandleFileImagen(a,b,1)}
                                name="imagenBanner"
                                type='file'

                            />
                            <br/>        
        
                            {imgBanner.imagePreviewUrl?
                                    <Segment basic>
                                        <Image src={"/info/resource/?nombre="+imgBanner.imagePreviewUrl} size="big" fluid />
                                    </Segment>
                                    
                                :
                                    "sin imagen"
        
                            }
        
                            </Form.Field>
        
                        
                             <Form.Field  >
                                <label>{strings?strings["imagenThumbnails"]:""} </label>
                                <Input placeholder='imagenThumbnails'
                                onChange={(a, b)=>onHandleFileImagen(a,b,2)}
                                name="imagenThumbnails"
                                type='file'

                            />    
                                    
                            {imgThumb.imagePreviewUrl?
                                    <Segment basic>
                                        <Image src={"/info/resource/?nombre="+imgThumb.imagePreviewUrl} size="big" fluid />
                                    </Segment>
                                    
                                :
                                    "sin imagen"
        
                            }        
                                    
                                    
                            </Form.Field>
         
                            <Form.Field  >
                                <label>{strings?strings["imagenBannerPresentacion"]:""} </label>
                                <Input placeholder='imagenBannerPresentacion'
                                onChange={(a, b)=>onHandleFileImagen(a,b,3)}
                                name="imagenBannerPresentacion"
                                type='file'

                            />
                                    
                                {imgPresentacion.imagePreviewUrl?
                                    <Segment basic>
                                        <Image src={"/info/resource/?nombre="+imgPresentacion.imagePreviewUrl} size="big" fluid />
                                    </Segment>
                                    
                                :
                                    "sin imagen"
        
                            }    
                                    
                                    
                            </Form.Field>
             
                          
                         
        
        
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/cursoscatn">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        </Container>
	);
};



export default CursoFormImagenes;